import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SessionManagerService } from './shared/services/session-manager.service';

@Component({
    selector: 'app-root',
    template: `
    <div class="app-shell">
      <app-header class="app-header"></app-header>

      <main class="app-main">
        <router-outlet></router-outlet>
      </main>

      <app-footer class="app-footer"></app-footer>
    </div>
  `,
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private sessionManager: SessionManagerService) {}

  ngOnInit(): void {
    this.sessionManager.start();
  }
}
